const screenMixin = {
  data () {
    return {
      screenWidth: null,
      labelWidth: '140px'
    }
  },
  mounted () {
    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },

  watch: {
    screenWidth: function (n, o) {
      if (n <= 1550) {
        this.labelWidth = '110px'
      } else if (n <= 2000) {
        this.labelWidth = '140px'
      } else {
        this.labelWidth = '200px'
      }
    }
  }
}

export default screenMixin
